import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson32: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav1@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson31"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">{`Food benefits `}</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson33"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-[1.5rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Protein</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Protein is vital for three major functions. It helps you grow
                  and repair muscles and other soft tissues. It is also a
                  building block of enzymes and hormones, which help regulate
                  processes in your body. Thirdly, protein is a fuel that your
                  body burns for energy.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Your body’s protein requirement depends on your weight. The
                  average adult needs about 0.8 grams of protein per kilogram of
                  body weight per day (around 7 grams for every 20 pounds of
                  body weight). So, a 140-pound person needs around 50 grams of
                  protein every day. The National Academy of Medicine recommends
                  that protein make up between 10% to 35% of your daily
                  calories.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Like fats and carbohydrates, protein is a macronutrient. This
                  means that your body needs it in large amounts. However, your
                  body doesn't store protein, so it is important to get enough
                  through your diet.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  You may need more protein if you lead a very active lifestyle.
                  Consuming large amounts of protein is most effective when you
                  space it out throughout your day, rather than consuming it all
                  in one meal. But beware of going overboard, as too much
                  protein can be hard on your kidneys and liver and might lead
                  to osteoporosis.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Protein Supplements</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Protein supplements are also widely available. The most common
                  form is protein powder, of which there are three main types:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>{`Whey, Soy & Casein`}</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Amino acids are the building blocks of protein. Complete
                  proteins, like whey, contain all nine amino acids that the
                  body needs to get from food.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>7 Types of High Protein Food</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The following 7 high protein foods are healthier alternatives to
                red meat:
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>
                    <span>Fish</span>
                  </span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <b>Fish</b>
                  <span>{` is one of the healthiest sources of protein available. That's because it is packed with many other essential nutrients, such as: Omega-3 fatty acids, Vitamin D, Calcium, Iron, Zinc, Magnesium & Potassium.`}</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Fish is also high in protein. Three ounces of Atlantic
                    salmon contain 22 grams of protein, while the same amount of
                    cod contains 19 grams.
                  </span>
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[34.63rem] object-cover"
            alt=""
            src="/129@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Poultry</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Any kind of bird raised primarily for meat and eggs is
                  considered poultry.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Chicken is one of the most common poultry sources of protein.
                  A 3-ounce serving of chicken breast contains an impressive 26
                  grams of protein. Turkey has slightly less protein, with 25
                  grams in 3 ounces.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[19.44rem] object-cover"
            alt=""
            src="/130@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Beans</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  One serving of beans provides the same amount of protein as 1
                  ounce of meat — about 7 grams. Beans also keep you full for
                  longer because, unlike animal sources of protein, they are
                  rich in fibre.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22rem] object-cover"
            alt=""
            src="/131@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Nuts</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Just one ounce of nuts contains anywhere from 3 to 7 grams of
                  protein and 1 to 3 grams of fibre. Almonds and pistachios are
                  among the most protein-rich nuts, with 21.15 and 20.16 grams
                  per 100 grams, respectively.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Almonds are a rich source of vitamin E, copper, magnesium,
                  good quality protein, and healthy unsaturated fatty acids.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have revealed that almonds can potentially help
                  prevent cardiovascular diseases, cut the risk of cancer, and
                  help prolong life
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[23.13rem] object-cover"
            alt=""
            src="/132@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Dairy Products</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Although many cheeses aren't the healthiest sources of protein
                  due to their high saturated fat contents, cottage cheese is an
                  exception. One cup of low-fat cottage cheese contains 180
                  milligrams of calcium and 26 grams of protein.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Greek yogurt is another protein-rich dairy product. It
                  contains two to three times the amount of protein in regular
                  yogurt.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[24.19rem] object-cover"
            alt=""
            src="/133@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.56rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 text-[1.5rem] pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Eggs</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Eggs make for an excellent source of protein, as they are:
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>Low-carb</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Low-calorie</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>Low-cost</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>&nbsp;</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>
                  Most of the protein in eggs is found in the whites, which also
                  contain vitamin D, omega-3 fatty acids, B vitamins, and
                  choline. Eggs are a complete protein, as they contain all nine
                  essential amino acids.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.88rem] object-cover"
            alt=""
            src="/134@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Lentils</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  People who pursue a vegan or vegetarian lifestyle remove many
                  common sources of protein from their diet. Lentils are a great
                  plant-based alternative, as 100 grams of raw lentils contain
                  nearly 25 grams of protein.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  This type of legume is also an excellent source of fibre.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.88rem] object-cover"
            alt=""
            src="/135@2x.png"
          />
        </div>
        <b className="self-stretch relative text-[1.88rem] tracking-[0.02em] leading-[2rem] text-justify">{`Fruit & Vegetables`}</b>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Apples</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Apples are sometimes called “nutritional powerhouses” because
                  of their impressive nutritional profile.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>{`Apples contain about 14 percent of our daily needs of Vitamin C (a powerful natural antioxidant), B-complex vitamins, dietary fibre, `}</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  phytonutrients (which help protect the body from the
                  detrimental effects of free radicals), and minerals such as
                  calcium and potassium.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have revealed that eating apples can potentially help
                  prevent dementia and reduce the risk of stroke and diabetes.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[23.5rem] object-cover"
            alt=""
            src="/136@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Arugula</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Along with other leafy greens, arugula contains very high
                  nitrate levels (more than 250 milligrams per 100 grams). High
                  intakes of dietary nitrate have been shown to lower blood
                  pressure, reduce the amount of oxygen needed during exercise,
                  and enhance athletic performance.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of arugula include lowering the
                  risk of cancer, preventing osteoporosis, and improving muscle
                  oxygenation during exercise.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/138@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Asparagus</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Asparagus is very rich in dietary fibre and contains high
                  levels of vitamin B6, calcium, zinc, and magnesium.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of asparagus include: reducing
                  the risk of diabetes, preventing kidney stones, and lowering
                  the risk of neural tube defects in babies.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Asparagus is also a natural diuretic, which can help with
                  fluid balance in the body and influence blood pressure and
                  edema.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Read more about asparagus.</span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/139@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Bananas</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Bananas are naturally free of fat, cholesterol, and sodium,
                  and very rich in potassium.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of bananas include: lowering
                  blood pressure, reducing the risk of developing childhood
                  leukemia, and supporting heart health.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/140@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Basil</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Basil is rich in vitamin A, vitamin K, vitamin C, magnesium,
                  iron, potassium, and calcium.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have revealed that basil can potentially reduce
                  inflammation and swelling, prevent the harmful effects of
                  aging, and may be useful in treating arthritis and
                  inflammatory bowel diseases.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/141@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Beetroot</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Beetroot, also known simply as the beet, has been gaining in
                  popularity as a new super food due to recent studies claiming
                  that beets and beetroot juice can improve athletic
                  performance, lower blood pressure and increase blood flow.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  This is partly due to its high content of nitrates, which
                  increase nitric oxide in the body and play a substantial role
                  in heart and vascular health.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Beetroot is a rich source of folate and manganese, and also
                  contains thiamine, riboflavin, vitamin B-6, pantothenic acid,
                  choline, betaine, magnesium, phosphorus, potassium, zinc,
                  copper, and selenium.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/142@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Bok Choy</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Bok choy belongs to the cruciferous vegetable family, which
                  also includes kale, broccoli, cauliflower, Brussels sprouts,
                  cabbage, collard greens, rutabaga, and turnips.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  These nutrition powerhouses supply loads of nutrients for
                  little calories. If you are trying to eat healthier,
                  cruciferous vegetables like bok choy should be at the very top
                  of your grocery list.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/143@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Broccoli</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Broccoli contains high levels of fibre (both soluble and
                  insoluble) and is a rich source of vitamin C.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  In addition, broccoli is rich in vitamin A, iron, vitamin K,
                  B-complex vitamins, zinc, phosphorus, and phytonutrients.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that broccoli can potentially help prevent
                  osteoarthritis Trusted Source, protect skin against the
                  effects of UV light, reverse diabetes heart damage, and reduce
                  bladder cancer risk.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/144@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Cantaloupe Melon</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Cantaloupes are also commonly known as muskmelons, mush
                  melons, rock melons, and Persian melons. They are a member of
                  the botanical family Cucurbitaceae, along with honeydew and
                  watermelons.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Cantaloupe contains an abundance of antioxidants, including
                  choline, zeaxanthin, and beta-carotene, all of which protect
                  against a range of diseases and conditions from the common
                  cold to cancer.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Potential health benefits of cantaloupe include lowering risk
                  of developing asthma, managing blood pressure, aiding
                  digestion, keeping hydrated, and reducing inflammation.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/145@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Carrots</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Carrots are a great source of vitamin A. They provide 210
                  percent of an average adult’s needs for the day.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of carrots include: preventing
                  lung cancer destroying leukemia cells and inhibiting their
                  progression, and helping to restore vision.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/146@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Cauliflower</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Cauliflowers are a member of the brassica family, more
                  commonly known as cruciferous vegetables.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  They contain antioxidants and phytonutrients that can protect
                  against cancer.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  They also contain fibre that helps with satiety, weight loss,
                  and a healthy digestive tract, choline that is essential for
                  learning and memory, as well as many other important
                  nutrients.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of cauliflower include
                  preventing mutations and reducing stress from free radicals,
                  preventing constipation, and helping memory.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/147@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Celery</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Celery is a very rich source of antioxidants, electrolytes,
                  and vitamin K. Also, thanks to its high water content, it can
                  help rehydrate.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of celery include: lowering
                  blood pressure, preventing cancer, and soothing joint pain.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/148@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Chickpeas</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Originally cultivated in the Mediterranean and the Middle
                  East, chickpeas, also known as garbanzo beans, have spread
                  their culinary influence throughout the world.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of chickpeas include improved
                  glucose levels, lipids, and insulin levels for diabetes,
                  maintaining bone strength and heart health.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/149@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Chives</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Chives are a nutrient-dense food, meaning that while they are
                  low in calories, they are high in beneficial nutrients like
                  vitamins, minerals, and antioxidants.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of chives include potential
                  beneficial and preventative effects against cancer, prostate
                  cancer, esophageal and stomach cancer, and positive effects on
                  sleep and mood.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/150@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Cilantro</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Known as coriander in the United Kingdom, cilantro comes from
                  the plant Coriandrum sativum. In the United States, the leaves
                  of the plant are referred to as cilantro (the Spanish
                  translation), and the seeds are referred to as coriander.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Many studies have suggested that increasing consumption of
                  plant foods like cilantro decreases the risk of obesity,
                  overall mortality, diabetes, and heart disease while promoting
                  a healthy skin and hair, increased energy, and overall lower
                  weight.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.25rem] object-cover"
            alt=""
            src="/151@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Cinnamon</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Studies have found that cinnamon can potentially be effective
                  against HIV, improve glucose and lipid levels in patients with
                  type 2 diabetes, help prevent Alzheimer’s, and stop the
                  destructive process of multiple sclerosis.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  In addition, researchers at Penn State found that consuming
                  cinnamon can help reduce the body’s negative responses to
                  eating high-fat meals.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.19rem] object-cover"
            alt=""
            src="/152@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Coffee</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Coffee is one of the main sources of antioxidants in the U.S.
                  population.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of drinking coffee in moderation
                  include: protecting against type 2 diabetes, preventing
                  Parkinson’s disease, lowering the risk of liver cancer,
                  preventing , and promoting good heart health.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.19rem] object-cover"
            alt=""
            src="/153@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Collard Greens</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Collard greens are part of the cruciferous vegetable family,
                  which also includes kale, broccoli, Brussels sprouts, cabbage,
                  rutabaga, and turnips.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Collard greens are an extremely rich source of vitamin K and
                  also contain folate, thiamin, niacin, pantothenic acid,
                  choline, phosphorus, and potassium.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Health benefits of collard greens may include assisting with
                  bone health, reducing cancer risk, helping lower glucose
                  levels in those with diabetes, and improving sleep and mood.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[24.13rem] object-cover"
            alt=""
            src="/154@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Cranberries</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Cranberries are a good source of vitamin C, fibre, and vitamin
                  E.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that cranberries can potentially reduce the
                  risk of cardiovascular disease (CVD), slow tumour progression,
                  prevent urinary tract infections, and benefit oral health by
                  preventing bacteria from binding to teeth.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[24.13rem] object-cover"
            alt=""
            src="/155@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Edamame</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Edamame is a young soybean that has been harvested before the
                  beans have had a chance to harden. They can be bought shelled
                  or in the pod, fresh or frozen.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of edamame include maintaining a
                  healthy blood pressure, helping with depression, promoting
                  fertility, and decreasing bone loss.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[24.13rem] object-cover"
            alt=""
            src="/156@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Eggplant</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  The eggplant, also known as aubergine, garden egg, guinea
                  squash, melongene, and brinjal, is usually distinguishable by
                  its signature egg-like shape and vibrant purple colour.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of eggplant include supporting
                  heart health, maintaining weight and blood cholesterol levels,
                  and anti-cancer effects.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[24.13rem] object-cover"
            alt=""
            src="/157@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>22. Flaxseed</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Flaxseed is not only “an excellent source of two fatty acids
                  that are essential for human health – linoleic acid and
                  alpha-linolenic acid,” but also “an excellent source of fibre
                  and a good source of minerals and vitamins,” according to the
                  American Nutrition Association.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits associated with flaxseed
                  include: lowering cholesterol, protecting against cancer,
                  preventing hot flashes, and improving blood sugar levels.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[24.13rem] object-cover"
            alt=""
            src="/158@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Garlic</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Garlic is widely used for several conditions linked to the
                  blood system and heart.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that garlic can potentially be a very
                  powerful antibiotic, help protect the heart during cardiac
                  surgery and after a heart attack, lower the risk of developing
                  lung cancer, and reduce high cholesterol and blood pressure
                  levels.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[18.63rem] object-cover"
            alt=""
            src="/159@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Ginger</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Ginger contains a chemical that is used as an ingredient in
                  antacid, laxative, and anti-gas medications.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that ginger can potentially prevent
                  inflammation of the colon, reduce exercise-induced muscle
                  pain, help alleviate nausea caused by chemotherapy, and reduce
                  the severity of period pains.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[18.63rem] object-cover"
            alt=""
            src="/160@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b className="text-[1.5rem] font-dm-sans">
                  <span className="text-white">Grapes</span>
                </b>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <b className="text-[1.5rem] font-dm-sans">&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  The portability, texture, flavour, and variety of grapes have
                  made them a popular finger food in countries all over the
                  world.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  {`Studies have associated grapes with the prevention of cancer, heart disease, `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.medicalnewstoday.com/articles/159283.php"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      high blood pressure
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  , and constipation as well as decreasing the risk of obesity
                  and overall mortality.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[18.63rem] object-cover"
            alt=""
            src="/161@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Grapefruit</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Grapefruits are low in calories but full of nutrients. They
                  support clear, healthy skin, help to lower the risk of many
                  diseases and conditions and may even help with weight loss as
                  part of an overall healthy and varied diet.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of grapefruit include boosting
                  weight loss, maintaining healthy blood pressure and heart
                  health, and combating free radicals.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.44rem] object-cover"
            alt=""
            src="/1611@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Green Tea</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Green tea may well be one of the world’s healthiest drinks and
                  contains the highest amount of antioxidants of any tea.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that drinking green tea is associated with
                  a reduced risk of and may help fight prostate cancer.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[27.13rem] object-cover"
            alt=""
            src="/162@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Honey</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Honey possesses antiseptic and antibacterial properties.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that honey can potentially help prevent
                  (gastroesophageal reflux), shorten the duration of bacterial
                  diarrheal, help heal burns, minimize seasonal allergies, and
                  fight off infections.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[27.13rem] object-cover"
            alt=""
            src="/163@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Kale</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Kale is a great source of vitamin K, vitamin A, beta-carotene,
                  calcium, and vitamin C.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of kale include: reducing the
                  risk of certain cancers, lowering the risk of coronary artery
                  disease, and lowering levels of bad cholesterol.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.38rem] object-cover"
            alt=""
            src="/164@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Kiwifruit</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Kiwis are a nutrient dense food, meaning they are high in
                  nutrients and low in calories. The kiwifruit is higher in
                  vitamin C per ounce than most other fruits.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of eating kiwis include:
                  maintaining healthy skin tone and texture, reducing blood
                  pressure, and preventing heart disease and stroke.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.38rem] object-cover"
            alt=""
            src="/165@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Mango</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  The mango is a member of the drupe family, a type of plant
                  food in which an outer fleshy part surrounds a shell (what we
                  sometimes call a pit) with a seed inside. Olives, dates, and
                  coconuts are also types of drupes.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Many studies have suggested that increasing consumption of
                  plant foods like mangoes decreases the risk of obesity and
                  overall mortality, diabetes, heart disease, and promotes a
                  healthy complexion and hair, increased energy, overall lower
                  weight.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.38rem] object-cover"
            alt=""
            src="/166@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Milk</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Dairy products, like milk, are a great dietary source of
                  calcium. Calcium has many functions in the body, but its
                  primary job is the development and maintenance of healthy
                  bones and teeth.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Calcium is also important for blood-clotting and
                  wound-healing, maintaining normal blood pressure, and muscle
                  contractions, including heartbeat.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Milk also provides magnesium, phosphorus, vitamin A,
                  riboflavin, vitamins B-6 and B-12.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of milk include: maintaining
                  bone, blood pressure, and heart health, and providing an
                  increase in vitamin D. Deficiency in vitamin D has been
                  associated with depression, chronic fatigue, and PMS.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[30.63rem] object-cover"
            alt=""
            src="/167@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Milk Alternatives</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  There are many reasons you might search for an alternative for
                  dairy, the most common being allergies and lactose
                  intolerance.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Some people choose to not consume dairy to follow a vegan
                  diet, which avoids any foods that come from an animal,
                  including milk, cheese, eggs, and honey.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Others may cut dairy out of their diet to avoid hormones and
                  antibiotics in conventional milk, as an acne treatment, or
                  when following the popular “Paleo” diet.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Soy isoflavones have been shown to be beneficial in preventing
                  heart disease, and at least 10 milligrams per day can decrease
                  breast cancer recurrence by 25 percent. Increased soy
                  consumption may be beneficial for menopausal women.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[34.56rem] object-cover"
            alt=""
            src="/168@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Mint</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Mint, also known as mentha, is actually a genus of around
                  15-20 types of plants including peppermint and spearmint. Mint
                  oil is often used in toothpaste, gum, candy, and beauty
                  products while the leaves are used either fresh or dried for
                  teas and food.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Mint has one of the highest antioxidant capacities of any
                  food. Mint has possible positive effects on allergies, common
                  cold, indigestion, irritable bowel syndrome (IBS), and skin.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.88rem] object-cover"
            alt=""
            src="/169@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Mushrooms</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Mushrooms, though classified as vegetables in the food world,
                  are not technically plants. They belong to the fungi kingdom
                  and provide several important nutrients.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of mushrooms include helping to
                  inhibit the growth of cancer cells, regulating blood pressure,
                  and improving immune responses to infection.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.88rem] object-cover"
            alt=""
            src="/170@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Oats</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Oats contain high levels of a type of fibre known as
                  beta-glucan. Beta-glucan is known to help lower levels of bad
                  cholesterol.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of oats include: reducing the
                  risk of coronary artery disease, lowering the risk of
                  colorectal cancer, and lowering blood pressure.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.88rem] object-cover"
            alt=""
            src="/171@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Oily Fish</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Oily fish, such as salmon or mackerel, is an excellent source
                  of omega-3 oils and lean protein.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Potential health benefits of eating oily fish include:
                  preventing cardiovascular disease, reducing the risk of
                  rheumatoid arthritis, boosting infant sensory, cognitive, and
                  motor development, improving memory, protecting vision, and
                  preventing oral and skin cancers.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.88rem] object-cover"
            alt=""
            src="/172@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Olive Oil</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  People who regularly consume olive oil are at a lower risk of
                  developing cardiovascular diseases, including hypertension
                  (high blood pressure), stroke, and hyperlipidemia (high blood
                  cholesterol and triglyceride levels).
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  In addition, olive oil intake may help treat inflammation,
                  endothelial dysfunction (problems with the inner linings of
                  blood vessels), thrombosis and carbohydrate metabolism.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.88rem] object-cover"
            alt=""
            src="/173@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Onions</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Onions can vary in size, shape, colour, and flavour. The most
                  common types are red, yellow, and white onion.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Flavours can vary from sweet and juicy with a mild flavour to
                  sharp, spicy, and pungent, often depending on the season in
                  which they are grown and consumed. An estimated 105 billion
                  pounds of onions are harvested each year worldwide.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The possible health benefits of consuming onions include
                  lowering the risk of several types of cancer, improving mood,
                  and maintaining the health of skin and hair
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.69rem] object-cover"
            alt=""
            src="/174@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Oranges</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  An orange has over 170 different phytochemicals and more than
                  60 flavonoids, many of which have been shown to have
                  anti-inflammatory properties and strong antioxidant effects.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Oranges also contain thiamin, riboflavin, niacin, vitamin B-6,
                  folate, pantothenic acid, phosphorus, magnesium, manganese,
                  selenium, and copper. Because of their high vitamin C content
                  (over twice the daily need), oranges are associated with
                  boosting the immune system.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[25.69rem] object-cover"
            alt=""
            src="/175@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Oregano</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Oregano is a rich source of vitamin K and dietary
                  antioxidants.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that oregano has antimicrobial activity,
                  anti-inflammatory properties, and components in oregano may
                  help slow down or prevent the progression of disease in
                  patients with breast cancer.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[19.44rem] object-cover"
            alt=""
            src="/176@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Papaya</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Papayas grow in tropical climates and are also known as papaws
                  or pawpaws.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The possible health benefits of consuming papaya include a
                  reduced risk of heart disease, diabetes, cancer, aiding in
                  digestion, improving blood glucose control in people with
                  diabetes, lowering blood pressure, and improving wound
                  healing.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[21.94rem] object-cover"
            alt=""
            src="/177@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Peaches</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Peaches are a characteristically fuzzy fruit native to
                  northwest China. They are a member of the stone fruit family,
                  meaning that they have one large middle seed, along with
                  cherries, apricots, plums, and nectarines.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  One medium peach contains 2 percent or more daily value of
                  vitamins E and K, niacin, folate, iron, choline, potassium,
                  magnesium, phosphorus, manganese, zinc, and copper. They have
                  been shown to ward off obesity-related diseases, such as
                  diabetes, metabolic syndrome, and cardiovascular disease.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[21.94rem] object-cover"
            alt=""
            src="/178@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Peppermint</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Peppermint is used as a traditional or folk remedy for several
                  conditions and illnesses because of its calming effects.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of peppermint include: treating
                  the symptoms of irritable bowel syndrome (IBS), calming skin
                  irritation and itchiness, and preventing the onset of
                  headaches and associated symptoms.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[21.94rem] object-cover"
            alt=""
            src="/179@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Pineapple</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Pineapple is a source of important vitamins and minerals such
                  as thiamin, riboflavin, vitamin B-6, folate, pantothenic acid,
                  magnesium, manganese, and potassium. It also contains
                  antioxidants and polyphenols, such as beta-carotene.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Fresh pineapple is the only known source of an enzyme called
                  bromelain, which may help reduce joint pain and the symptoms
                  of arthritis, reduce inflammation, inhibit tumour growth, and
                  shorten recovery time following plastic surgery.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[39rem] object-cover"
            alt=""
            src="/180@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Potatoes</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Along with the tomato and eggplant, the potato plant belongs
                  to the nightshade family, of which some species are truly
                  poisonous. Today, potatoes are one of the cheapest universal
                  crops to produce and are available year-round.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The health benefits of consuming potatoes include maintaining
                  bone structure, supporting heart health, reducing chronic
                  inflammation, and preventing constipation.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[23.88rem] object-cover"
            alt=""
            src="/181@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Pumpkin</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Pumpkin is an extremely nutrient dense food, meaning it is
                  chock-full of vitamins and minerals but low in calories. There
                  are many creative ways pumpkin can be incorporated into your
                  diet, including desserts, soups, salads, preserves, and even
                  as a substitute for butter.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of pumpkin including supporting
                  heart health, eye health, promoting fertility, and giving
                  immunity a boost.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[23.88rem] object-cover"
            alt=""
            src="/182@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Quinoa</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Nutritionally, quinoa is considered a whole grain. Whole
                  grains include the entire intact grain seed without removing
                  any of its parts.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  In contrast, when grains are milled or refined like white
                  breads, white rice, and white pasta, they have been processed
                  to create a finer, lighter texture, and are not as nutrient
                  dense. Quinoa is also a great source of protein.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Consuming 2-3 servings of whole grain foods per day can reduce
                  the risk of cardiovascular disease, type 2 diabetes, high
                  blood pressure, colon cancer, and obesity. Many studies have
                  shown that as whole grain intake increases, the risk for all
                  five of these lifestyle-related conditions decreases.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[29.81rem] object-cover"
            alt=""
            src="/183@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Rosemary</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Rosemary is a rich source of antioxidants and
                  anti-inflammatory compounds.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that rosemary may potentially help treat
                  indigestion, enhance memory and concentration, provide
                  neurological protection, and provide protection against
                  macular degeneration.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[27rem] object-cover"
            alt=""
            src="/184@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Sage</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Sage is rich in antioxidants (apigenin, diosmetin, and
                  luteolin) and important nutrients, such as vitamin K.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that sage may potentially improve memory
                  and information processing among people who have mild
                  Alzheimer’s disease and help lower cholesterol and
                  triglyceride levels in patients with type 2 diabetes.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.06rem] object-cover"
            alt=""
            src="/185@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Spearmint</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Spearmint contains high amounts of vitamins, antioxidants, and
                  other vital nutrients.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that spearmint may potentially have
                  antioxidant and antifungal properties, reduce symptoms of
                  nausea and other digestive problems, and treat hirsutism
                  (abnormal hair growth).
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.06rem] object-cover"
            alt=""
            src="/186@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span> Strawberries</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Strawberries are one of the most popular, refreshing, and
                  healthy treats on the planet; they contain many vitamins and
                  antioxidants that can be beneficial for your health.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of strawberries include:
                  reducing the risk of heart disease, stroke, cancer, blood
                  pressure, constipation, allergies, diabetes, and depression.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.06rem] object-cover"
            alt=""
            src="/187@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Sweet potatoes</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Sweet potatoes pack a powerful nutritional punch. They have
                  over 400 percent of your daily needs for vitamin A in one
                  medium potato, plus high levels of fibre and potassium.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The potential health benefits of sweet potatoes include a
                  protective role against prostate cancer, promoting fertility,
                  boosting immunity, and supporting vision.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.06rem] object-cover"
            alt=""
            src="/188@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Thyme</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Thyme preparations may be more effective than acne
                  prescription creams, according to scientists at Leeds
                  Metropolitan University in England.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Studies have found that thyme may potentially protect against
                  hypertension, help fight off foodborne bacterial infections,
                  and induce cell death in breast cancer cells.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.06rem] object-cover"
            alt=""
            src="/189@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Tofu</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Tofu, made from soybean curds, is naturally gluten-free and
                  low calorie, contains no cholesterol, and is an excellent
                  source of protein, iron, and calcium.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The isoflavones (a type of compound called phytoestrogens) in
                  soy foods have been linked to a decreased risk for
                  osteoporosis, while the calcium and magnesium in soy may help
                  to lessen PMS symptoms, regulate blood sugar, and prevent
                  migraine headaches.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.06rem] object-cover"
            alt=""
            src="/190@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Tomatoes</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  The tomato has been referred to as a “functional food,” a food
                  that goes beyond providing just basic nutrition, additionally
                  preventing chronic disease and delivering other health
                  benefits, due to beneficial phytochemicals such as lycopene.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Tomatoes are a rich source of vitamins A and C and folic acid.
                  Tomatoes contain a wide array of beneficial nutrients and
                  antioxidants, including alpha-lipoic acid, lycopene, choline,
                  folic acid, beta-carotene, and lutein.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The benefits of consuming fruits and vegetables of all kinds,
                  including tomatoes, are infinite. As plant food consumption
                  goes up, the risk of heart disease, diabetes, and cancer goes
                  down.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[28.13rem] object-cover"
            alt=""
            src="/191@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Watermelon</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Watermelon contains thiamin, riboflavin, niacin, vitamin B-6,
                  folate, pantothenic acid, magnesium, phosphorus, potassium,
                  zinc, copper, manganese, selenium, choline, lycopene, and
                  betaine. Watermelon is a good source of lycopene.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  The possible health benefits of watermelon include asthma
                  prevention, reduction of high blood pressure, regulation of
                  digestion, inflammation reduction, and promotes healthy hair
                  and skin. Watermelon is also one of the best sources lycopene.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.63rem] object-cover"
            alt=""
            src="/192@2x.png"
          />
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson33"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson32;
